import './invoice.scss';
import React, { useEffect } from 'react';
import IdentifyPage from 'researcher/application/components/IdentifyPage';
import Loading from 'researcher/components/Loading';
import InvoiceHistory from './InvoiceHistory';
var Invoices = function Invoices(_ref) {
  var allowsFapiaoProcessingAfterPayment = _ref.allowsFapiaoProcessingAfterPayment,
    clearSelectedInvoiceNumbers = _ref.clearSelectedInvoiceNumbers,
    currency = _ref.currency,
    displayingUnpaidInvoices = _ref.displayingUnpaidInvoices,
    filteredInvoices = _ref.filteredInvoices,
    filters = _ref.filters,
    invoices = _ref.invoices,
    onChangeFilters = _ref.onChangeFilters,
    onChangePage = _ref.onChangePage,
    onFapiaoCancelled = _ref.onFapiaoCancelled,
    pageTitle = _ref.pageTitle,
    pages = _ref.pages,
    paginatedInvoices = _ref.paginatedInvoices,
    pagination = _ref.pagination,
    resetFilters = _ref.resetFilters,
    selectedInvoiceNumbers = _ref.selectedInvoiceNumbers,
    status = _ref.status,
    unpaidInvoicetotal = _ref.unpaidInvoicetotal,
    updateSelections = _ref.updateSelections;
  useEffect(function () {
    if (!displayingUnpaidInvoices) {
      clearSelectedInvoiceNumbers();
    }
  }, [displayingUnpaidInvoices]);
  if (!status.loaded) {
    return /*#__PURE__*/React.createElement(Loading, {
      text: "invoices-loading-message"
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "invoices"
  }, /*#__PURE__*/React.createElement(IdentifyPage, {
    title: "My Invoices"
  }), /*#__PURE__*/React.createElement("div", {
    className: "row justify-content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-75"
  }, /*#__PURE__*/React.createElement(InvoiceHistory, {
    allowsFapiaoProcessingAfterPayment: allowsFapiaoProcessingAfterPayment,
    currency: currency,
    displayingUnpaidInvoices: displayingUnpaidInvoices,
    filteredInvoices: filteredInvoices,
    filters: filters,
    invoices: invoices,
    onChangeFilters: onChangeFilters,
    onChangePage: onChangePage,
    onFapiaoCancelled: onFapiaoCancelled,
    pageTitle: pageTitle,
    pages: pages,
    paginatedInvoices: paginatedInvoices,
    pagination: pagination,
    resetFilters: resetFilters,
    selectedInvoiceNumbers: selectedInvoiceNumbers,
    unpaidInvoicetotal: unpaidInvoicetotal,
    updateSelections: updateSelections
  }))));
};
export default Invoices;